import { SeniorityModel } from '../ts/interfaces/models/SeniorityModel';
import { BaseService } from './baseService';

class SeniorityService extends BaseService<SeniorityModel> {
  controllerName = 'seniorities';
}

export const seniorityService = new SeniorityService();
